import request from "@/util/request";
/* POST /sys/sys_user/register
用户注册 */
export const register = (data) => {
        return request({
            url: "/sys/sys_user/register",
            method: "post",
            data,
        })
    }
    /* GET /sys/sys_user/sendVerificationCode
    发送手机验证码 */
export const sendVerificationCode = (params) => {
        return request({
            url: "/sys/sys_user/sendVerificationCode",
            method: "get",
            params,
        })
    }
    /* POST /sys/sys_user/verificationRegister
    注册校验 */
export const verificationRegister = (data) => {
        return request({
            url: "/sys/sys_user/verificationRegister",
            method: "post",
            data,
        })
    }
    /* POST /sys/sys_user/reSubmitUserInformation
    重新提交用户信息 */
export const reSubmitUserInformation = (data) => {
        return request({
            url: "/sys/sys_user/reSubmitUserInformation",
            method: "post",
            data,
        })
    }
    /* GET /com/user/getUserInformation
    获取用户注册信息 */
export const getUserInformation = (params) => {
        return request({
            url: "/com/user/getUserInformation",
            method: "get",
            params,
        })
    }
    /* POST /com/user/updateUser
    编辑用户信息 */
export const updateUser = (data) => {
    return request({
        url: "/com/user/updateUser",
        method: "post",
        data,
    })
}


// WEBPACK FOOTER //
// ./src/api/reg/index.js